import { ChangeEvent } from 'react';
import { colors, layout } from '../../NewHire/v2/styles';
import RatingItem from '../components/RatingItem';
import RatingScaleLegend from '../components/RatingScaleLegend';
import { ANNUAL_REVIEW_RATINGS, CORE_VALUES_SUBITEMS, SECTION_EXAMPLES_KEYS } from '../utils/questionsCatalog';

interface RatingSectionStepProps {
  section: 1 | 2 | 3 | 4;
  ratings: Record<string, number>;
  examples: Record<string, string>;
  onRatingChange: (key: string, value: number) => void;
  onExamplesChange: (sectionKey: string, value: string) => void;
}

const sectionTitle = (section: number) => {
  switch (section) {
    case 1:
      return 'The AEA Way (Core Performance)';
    case 2:
      return 'Team & Culture (How You Show Up)';
    case 3:
      return 'Growth & Mindset';
    case 4:
      return 'AEA Differentiators';
    default:
      return '';
  }
};

const RatingSectionStep = ({
  section,
  ratings,
  examples,
  onRatingChange,
  onExamplesChange,
}: RatingSectionStepProps) => {
  const items = ANNUAL_REVIEW_RATINGS.filter((q) => q.section === section);
  const sectionKey = SECTION_EXAMPLES_KEYS[`section${section}` as keyof typeof SECTION_EXAMPLES_KEYS];

  return (
    <div>
      <h2 style={{ ...layout.title, marginBottom: 4 }}>Section {section}</h2>
      <p style={layout.subtitle as any}>{sectionTitle(section)}</p>

      <RatingScaleLegend />

      <div style={{ marginTop: 20 }}>
        {items.map((item) => (
          <RatingItem
            key={item.key}
            title={item.title}
            description={item.description}
            whatItLooksLike={item.whatItLooksLike}
            value={ratings[item.key]}
            onChange={(v) => onRatingChange(item.key, v)}
          />
        ))}

        {section === 4 ? (
          <div
            style={{
              background: '#fff',
              border: `1px solid ${colors.border}`,
              borderRadius: 10,
              padding: 16,
              marginBottom: 14,
            }}
          >
            <h4 style={{ margin: '0 0 10px 0', fontSize: 15, fontWeight: 700, color: colors.text }}>
              AEA Core Values in Action
            </h4>
            <p style={{ margin: '0 0 14px 0', fontSize: 13, color: colors.muted, lineHeight: 1.45 }}>
              Demonstrates our values daily:
            </p>
            {CORE_VALUES_SUBITEMS.map((sub) => (
              <RatingItem
                key={sub.key}
                title={sub.label}
                value={ratings[sub.key]}
                onChange={(v) => onRatingChange(sub.key, v)}
              />
            ))}
          </div>
        ) : null}

        <div>
          <label style={layout.label as any}>Provide 1–2 specific examples that support your ratings above</label>
          <textarea
            value={examples[sectionKey] || ''}
            onChange={(e: ChangeEvent<HTMLTextAreaElement>) => onExamplesChange(sectionKey, e.target.value)}
            rows={4}
            style={{ ...(layout.input as any), resize: 'vertical', fontFamily: 'inherit' }}
            placeholder="Examples"
          />
        </div>
      </div>
    </div>
  );
};

export default RatingSectionStep;
